import React from "react";

const formatCurrency = (value) =>
  value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

const AlexSaverCreditCard = () => {
  const agi = 45000;
  const contribution = 4000;

  const taxBefore = 1350;          // tax before nonrefundable credits
  const creditRate = 0.4;          // 40% in this example
  const creditBase = 4000;         // eligible contribution amount

  const saversCreditRaw = creditBase * creditRate; // 1600 (raw calculation)

  // Saver’s Credit CANNOT exceed taxBefore because it is NONREFUNDABLE
  const saversCredit = Math.min(saversCreditRaw, taxBefore); // capped at 1350

  // Final tax owed after applying the credit
  const finalTax = Math.max(0, taxBefore - saversCredit); // 0

  const taxSavings = saversCredit;

  return (
    <section
      style={{
        maxWidth: "720px",
        margin: "24px auto",
        padding: "18px 16px 20px",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <h2
        style={{
          margin: "0 0 6px",
          fontSize: "1.2rem",
          fontWeight: 700,
          color: "#0f172a",
        }}
      >
Saver’s Credit Example
      </h2>
      <p
        style={{
          fontSize: "0.9rem",
          color: "#64748b",
          margin: "0 0 12px",
        }}
      >
         A simplified example showing how the Saver’s Credit affects tax in one scenario.
      </p>
<p> A married couple filing jointly with an AGI of $45,000 contributes $4,000 to a retirement account.</p>
      {/* Main card */}
      <div
        style={{
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
          backgroundColor: "#f8fafc",
          fontSize: "0.9rem",
        }}
      >
        {/* AGI */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <span>Adjusted Gross Income (AGI)</span>
          <span>{formatCurrency(agi)}</span>
        </div>

        {/* Contribution */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: "1px solid #e2e8f0",
            backgroundColor: "#ecfdf3", // soft green
          }}
        >
          <span>Retirement contribution</span>
          <span>{formatCurrency(contribution)}</span>
        </div>

        {/* Tax before credit */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <span><strong>Tax before Saver&apos;s Credit</strong></span>
          <span><strong>{formatCurrency(taxBefore)}</strong></span>
        </div>

        {/* Saver's Credit */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: "1px solid #e2e8f0",
            backgroundColor: "#fef9c3", // soft yellow highlight
          }}
        >
          <span>
           <strong>Saver&apos;s Credit (example) 
          </strong>
          </span>
          <span style={{ color: "#166534", fontWeight: 600 }}>
           <strong> -{formatCurrency(saversCredit)}</strong>
          </span>
        </div>

        {/* Final tax */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 12px",
            backgroundColor: "#e0f2fe", // soft blue
          }}
        >
          <span>Final tax in this example</span>
          <span style={{ fontWeight: 600 }}>
            {formatCurrency(finalTax)}
          </span>
        </div>
      </div>

      {/* Savings highlight */}
      <div
        style={{
          marginTop: "12px",
          padding: "10px 12px",
          borderRadius: "10px",
          backgroundColor: "#ecfdf5", // greenish card (from your palette)
          border: "1px solid #bbf7d0",
          fontSize: "0.9rem",
          color: "#065f46",
        }}
      >
        In this sample scenario, the Saver&apos;s Credit reduces their tax
        by <strong>{formatCurrency(taxSavings)}</strong>, from{" "}
        {formatCurrency(taxBefore)} down to {formatCurrency(finalTax)}. 
      </div>
    </section>
  );
};

export default AlexSaverCreditCard;
